'use client';
import React from 'react';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4 max-w-5xl">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark font-avenir mb-4">
            Trusted Plot Developers & Real Estate Experts
          </h2>
          <hr className="border-0 h-0.5 bg-brand-green w-20 mx-auto" />
        </div>

        {/* Content */}
        <div className="grid md:grid-cols-2 gap-8 items-start">
          <div>
            <blockquote className="relative pl-6 border-l-4 border-brand-turmeric mb-6">
              <span className="absolute -top-2 -left-2 text-5xl text-brand-turmeric/30 font-serif leading-none">&ldquo;</span>
              <p className="text-brand-gray font-avenir text-base leading-relaxed italic">
                Upscaling Wealth. Transforming New Horizons.
              </p>
              <span className="text-5xl text-brand-turmeric/30 font-serif leading-none">&rdquo;</span>
            </blockquote>
            <hr className="border-0 h-px bg-brand-dark/20 my-4" />
          </div>
          <div className="space-y-4">
            <p className="text-brand-gray font-avenir text-sm leading-relaxed">
              Neo Capital Group brings together the finest minds in finance, engineering, and real estate to create a platform where wealth meets opportunity. Our multidisciplinary team is driven by a singular purpose — to make premium land investments accessible, transparent, and rewarding for every stakeholder.
            </p>
            <p className="text-brand-gray font-avenir text-sm leading-relaxed">
              From DTCP/HMDA/FCDA/GHMC Municipal Limits Approved and RERA registered properties, every project is built with proper planning, documentation clarity, and infrastructure-focused development standards — ensuring secure land ownership and future appreciation potential.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
